import { QueryClient } from "@tanstack/react-query";
import { UnauthorizedError } from "./apiClient";

/**
 * Singleton TanStack Query client.
 *
 * Konfigurace per REQ-API-012 + REQ-PERF-001 (NFR-001 API p95 < 500 ms):
 *   - retry 1 (kromě mutations) — vyhneme se rate-limit triggeru po 429
 *     `/auth/refresh` (per Phase 3 rate limit config 20/min/session).
 *   - 401 (expirovaná session) se NEretryuje — globální handler v apiClient
 *     pošle user na /login; opakovat request nemá smysl a triggeroval by
 *     druhý redirect.
 *   - staleTime 30 s default — TanStack Query cache invalidation v admin UI
 *     trigerujeme manuálně po POST/PUT.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof UnauthorizedError) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
